var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSectionHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19C3 19.55 3.19583 20.0208 3.5875 20.4125C3.97917 20.8042 4.45 21 5 21H19C19.55 21 20.0208 20.8042 20.4125 20.4125C20.8042 20.0208 21 19.55 21 19V15C21 14.45 20.8042 13.9792 20.4125 13.5875C20.0208 13.1958 19.55 13 19 13H5C4.45 13 3.97917 13.1958 3.5875 13.5875C3.19583 13.9792 3 14.45 3 15V19ZM19 15V19H5V15H19Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V7L11 5V3H19C19.55 3 20.0208 3.19584 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9C21 9.55 20.8042 10.0208 20.4125 10.4125C20.0208 10.8042 19.55 11 19 11H13.5H11C11 11 11 9.55 11 9V8.5Z",
    fill: "#3DDB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3H9L9 11H7V8L5 8V11H3V3H5V6L7 6V3Z",
    fill: "#3DDB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSectionHeader);
export default __webpack_public_path__ + "static/media/add_section_header.b9e6cc868a937b1a7c7dcd6559fae85e.svg";
export { ForwardRef as ReactComponent };